import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createSlots as _createSlots } from "vue"

import {
  ref,
  PropType,
  computed,
  CSSProperties,
  getCurrentInstance,
  h,
  defineComponent,
  Component,
} from 'vue';

import router from '@/router';
import { childrenType } from '../../types';
import { useLayoutStoreHook } from '@/store/modules/layout';


export default /*#__PURE__*/_defineComponent({
  props: {
  item: {
    type: Object as PropType<childrenType>,
    required: true,
  },
  isNest: {
    type: Boolean,
    default: false,
  },
  basePath: {
    type: String,
    default: '',
  },
},
  setup(__props) {

const props = __props

const layoutStore = useLayoutStoreHook();

const showMenuLabel = computed(() => {
  return layoutStore.layout !== 'inline' && layoutStore.opened;
});
//const instance = getCurrentInstance().appContext.app.config.globalProperties;


const getNoDropdownStyle = computed((): CSSProperties => {
  return {
    display: 'flex',
    alignItems: 'center',
  };
});

const getDivStyle = computed((): CSSProperties => {
  return {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    overflow: 'hidden',
  };
});

const onlyOneChild = ref<childrenType>();

function hasOneShowingChild(
  children: childrenType[] = [],
  parent: childrenType
) {
  const showingChildren = children.filter((item: any) => {
    onlyOneChild.value = item;
    return true;
  });
  if (showingChildren.length === 1) {
    return true;
  }

  if (showingChildren.length === 0) {
    onlyOneChild.value = { ...parent, noShowingChildren: true };
    return true;
  }
  return false;
}

function resolvePath(routePath: string) {
  const httpReg = /^http(s?):\/\//;
  if (httpReg.test(routePath)) {
    return props.basePath + '/' + routePath;
  } else {
    let newPath = '';
    if (!props.basePath) {
      newPath = routePath;
    } else if (routePath.indexOf(props.basePath) === 0) {
      newPath = routePath;
    } else {
      //newPath = props.basePath + routePath;
      newPath = routePath;
    }
    return newPath;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_sidebar_item = _resolveComponent("sidebar-item", true)!
  const _component_a_sub_menu = _resolveComponent("a-sub-menu")!

  return (
      hasOneShowingChild(props.item.children, props.item) &&
      (!onlyOneChild.value!.children || onlyOneChild.value!.noShowingChildren)
    )
    ? (_openBlock(), _createBlock(_component_a_menu_item, {
        key: resolvePath(onlyOneChild.value!.path),
        style: _normalizeStyle(_unref(getNoDropdownStyle))
      }, {
        default: _withCtx(() => [
          (onlyOneChild.value && onlyOneChild.value.meta && onlyOneChild.value.meta.icon)
            ? (_openBlock(), _createBlock(_component_svg_icon, {
                key: 0,
                icon: onlyOneChild.value!.meta!.icon,
                class: "anticon"
              }, null, 8, ["icon"]))
            : _createCommentVNode("", true),
          _createElementVNode("span", null, _toDisplayString(onlyOneChild.value!.meta && (onlyOneChild.value!.meta.i18n? _ctx.$t(onlyOneChild.value!.meta.title || 'xxx') : onlyOneChild.value!.meta?.title)), 1)
        ]),
        _: 1
      }, 8, ["style"]))
    : (_openBlock(), _createBlock(_component_a_sub_menu, {
        ref: "subMenu",
        key: resolvePath(props.item.path),
        "popper-append-to-body": ""
      }, _createSlots({
        title: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(props.item.meta &&
          (props.item.meta.i18n
            ? _ctx.$t(props.item.meta.title || 'xxx')
            : props.item.meta?.title)), 1)
        ]),
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.item.children, (child) => {
            return (_openBlock(), _createBlock(_component_sidebar_item, {
              key: child.path,
              "is-nest": true,
              item: child,
              "base-path": resolvePath(child.path),
              class: "nest-menu"
            }, null, 8, ["item", "base-path"]))
          }), 128))
        ]),
        _: 2
      }, [
        (props.item.meta && props.item.meta.icon)
          ? {
              name: "icon",
              fn: _withCtx(() => [
                _createVNode(_component_svg_icon, {
                  icon: props.item.meta!.icon!,
                  class: "avticon"
                }, null, 8, ["icon"])
              ])
            }
          : undefined
      ]), 1024))
}
}

})